import { Loader2 } from "lucide-react";
import { ServiceCatalogItem } from "../../../types/service-catalog";
import { Button } from "../../ui/button";
import { Separator } from "../../ui/separator";
import { EnvVarEditor } from "../env-vars";

interface ServiceEnvVarsStepProps {
  selectedTemplate: ServiceCatalogItem;
  envVars: Record<string, string>;
  onEnvVarsChange: (vars: Record<string, string>) => void;
  onBack: () => void;
  onCreate: () => void;
  isCreating: boolean;
  /** When true, hides the section heading and footer buttons.
   *  The parent page owns those in the two-column wizard layout. */
  embedded?: boolean;
}

export function ServiceEnvVarsStep({
  selectedTemplate,
  envVars,
  onEnvVarsChange,
  onBack,
  onCreate,
  isCreating,
  embedded = false,
}: ServiceEnvVarsStepProps) {
  return (
    <div className="space-y-6">
      {!embedded && (
        <div>
          <p className="text-sm font-medium">Environment Variables</p>
          <p className="text-xs text-muted-foreground mt-0.5">
            Runtime values injected into your container. You can always add or
            change these after deployment from the Environment Variables tab —
            this step is optional.
          </p>
        </div>
      )}

      <EnvVarEditor defaultValue={envVars} onChange={onEnvVarsChange} />

      {!embedded && (
        <>
          <Separator />
          <div className="flex justify-between items-center">
            <Button variant="outline" onClick={onBack} disabled={isCreating}>
              ← Back
            </Button>
            <Button onClick={onCreate} disabled={isCreating}>
              {isCreating ? (
                <>
                  <Loader2 className="h-4 w-4 animate-spin mr-2" />
                  Deploying…
                </>
              ) : (
                `Deploy ${selectedTemplate.displayName}`
              )}
            </Button>
          </div>
        </>
      )}
    </div>
  );
}
